module.exports = __webpack_public_path__ + "static/img/Logo_eTaxi.8fcd58c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Logo_eTaxi.png
// module id = 8ffd
// module chunks = 1